import { Appbar } from "react-native-paper";
import type { MobileHeaderProps } from "./types";

const MobileHeader = ({
	selectedCount,
	onBackPress,
	onDelete,
}: MobileHeaderProps) => {
	return (
		<Appbar.Header style={{ paddingVertical: 8, paddingHorizontal: 4, gap: 4 }}>
			<Appbar.Action icon="arrow-left" onPress={onBackPress} />
			<Appbar.Content title={`${selectedCount} selected`} />
			<Appbar.Action icon="delete-outline" onPress={() => onDelete([])} />
		</Appbar.Header>
	);
};

export default MobileHeader;
